import React, { useEffect } from "react";
import LoadCSSforfirstTime from "../../../../../CloudStorage/LoadCSSforfirstTime";
import CloudStorage from "../../../../../CloudStorage/CloudStorage";
import { useDispatch, useSelector } from "react-redux";
import { FilterActionListings } from "../../../../../redux/auction/action";
import { useAllFilterBaseContext } from "../../../../../Context/AllFilterBaseContext";
import PostNotFound from "../../../../CustomComponents/AllLoader/PostNotFound";
import YourPost from "../../../../Common/Label/YourPost";
import PostReportMenu from "../../../../Common/Label/PostReportMenu";
import { Commas } from "../../../../Common/AllDateTimeReleventFormate";
import ActionStatusLabel from "../../../../Common/Label/ActionStatusLabel";
import { navigateToNextTab } from "../../../../Common/FewCommonMethods";
import CommonPagination from "../../../../Common/PaginationComponet/CommonPagination";
import CommonTooltip from "../../../../Common/CommonTooltip";

const size = 15;

export default function AllAuctionListing({ proposed, viewed, saved = 0 }) {
  const path = "Assets/scss/FindWork.module.scss";
  const dispatch = useDispatch();
  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);

  const { state, setPageNumber } = useAllFilterBaseContext();
  const { pageNumber } = state;
  const getallaction = useSelector(
    ({ auction: { getfilterdaction } }) => getfilterdaction
  );
  const getauctionlist = getallaction?.response || [];

  const data = {
    method: "GET",
    index: pageNumber,
    size: size,
    proposed: proposed,
    viewed: viewed,
    search: state?.search,
    wishlist: saved,
    filter: [
      {
        id: "32",
        title: "Delivery Type",
        values: state?.deliverytype,
      },
      {
        id: "33",
        title: "sort by",
        values: state?.sortByTime,
      },
      {
        id: "34",
        title: "Status",
        values: state?.statustype,
      },
      {
        id: "31",
        title: "Buy & Sell with Auction (BSA) Type",
        filter_type: "2",
        values: state?.sortAuction,
      },
      {
        id: "35",
        min: state.minHourlyRate,
        max: state.maxHourlyRate,
      },
    ],
  };

  useEffect(() => {
    dispatch(FilterActionListings(data));
  }, [state]);

  const handleImageError = (e) => {
    e.target.src = `${CloudStorage.cloudurl}/Assets/Images/expertregisteration/file-upload.png`;
  };

  return (
    <div className="col-lg-9 col-md-8 filter-right">
      <h2>Recent Buy & Sell with Auction (BSA) Post</h2>
      {Array.isArray(getauctionlist) && getauctionlist.length > 0 ? (
        <div className="row auction-row">
          {Array.isArray(getauctionlist) &&
            getauctionlist?.map((item, index) => {
              return (
                <div className="col-lg-4 col-md-6" key={index}>
                  <div className="d-flex post-sold"> <YourPost item={item} /></div>
                  <div
                    className="auction-det"
                    style={{ position: "relative" }}
                    onClick={
                      () => navigateToNextTab(`auctiondetails/${item.id}`)
                      // navigate(`/${lan}/`auctiondetails`/${item?.id}`)
                    }
                  >
                    <PostReportMenu item={item} masterType={2} />
                    {Array.isArray(item?.files) && item?.files[0] ? (
                      <div className="w-100 auction-img">
                        <img
                          src={item?.files[0]?.file}
                          className="cover-img w-100 h-100"
                          style={{ objectFit: "cover" }}
                          alt="Certificate"
                          onError={handleImageError}
                        />
                      </div>
                    ) : (
                      <img
                        src={`${CloudStorage.cloudurl}/Assets/Images/hireexpert/hireexpert-1.png`}
                        className="w-100 auction-img h-100"
                        style={{ objectFit: "cover" }}
                        alt=""
                      />
                    )}
                    <h4>{item?.title}</h4>
                    <div className="minimum-bid">
                      <div>
                        <p>Minimum bid</p>
                        <h6>SAR {Commas(item?.min_bid)}</h6>
                      </div>
                      <div>
                        <h5>
                          <img
                            src={`${CloudStorage.cloudurl}/Assets/Images/common/hand-tick.svg`}
                            alt=""
                          />
                          {item?.bid_count || 0}
                        </h5>
                      </div>
                    </div>
                    <div className="increment">
                      <p
                        className={`end-in mb-3 ${item?.auction_type == 2 ? "incremental-auction" : "sealed-auction"
                          }`}
                      >
                        <img
                          src={`${CloudStorage.cloudurl}/Assets/Images/contestdetails/arrow-up.svg`}
                          alt=""
                        />

                        {item?.auction_type == 2 ? "Incremental" : "Sealed Auction"}

                        {item?.auction_type == 2 ? (
                          <CommonTooltip
                            dontshowtitle={true}
                            info={"Each new bid must be slightly higher than the last one."}
                          />
                        ) : (
                          <CommonTooltip
                            dontshowtitle={true}
                            info={"Bids are confidential until the auction ends."}
                          />
                        )}
                      </p>
                    </div>
                    <ActionStatusLabel item={item} />
                  </div>
                </div>
              );
            })}
          <CommonPagination
            totalitemcounts={getallaction?.count?.count}
            size={size}
            pageNumber={state?.pageNumber}
            setPageNumber={setPageNumber}
          />
        </div>
      ) : (
        <PostNotFound title={"Recent Auction Post Not Found..."} />
      )}
    </div>
  );
}
